import { render } from "./TurmoilAgenda.vue?vue&type=template&id=eaa88470&ts=true"
import script from "./TurmoilAgenda.vue?vue&type=script&lang=ts"
export * from "./TurmoilAgenda.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__